import {
  FieldSettingsAreaLayout,
  HeaderSettingsWrapper,
  HeaderSettingsWrapperProps,
} from 'modules/settingsContainer/FieldSettingsArea/styles';
import { FC, NoopType } from 'types/global';
import { ColorVarsEnum } from 'enums/ColorVarsEnum';
import { PrimaryTextSpan } from 'styles/TextsElements';
import { Button } from 'modules/ui';
import { ClearIcon } from 'assets/icons/withContainer';
import { FlexContainer } from 'styles/FlexContainer';
import React from 'react';
import { settingsTabHeight } from 'modules/ui/tabs/SettingsTabs/constants';
import { settingsLayoutWidth } from 'modules/settingsContainer/SettingsLayout/constants';

export interface HeaderSettingsAreaLayoutProps extends HeaderSettingsWrapperProps {
  headerText: string;
  onClose: NoopType;
}

export const HeaderSettingsAreaLayout: FC<HeaderSettingsAreaLayoutProps> = ({
  headerText,
  children,
  onClose,
  ...headerProps
}) => (
  <HeaderSettingsWrapper {...headerProps}>
    <FlexContainer
      padding="0  4px 0 12px"
      height={settingsTabHeight}
      backgroundColor={`var(${ColorVarsEnum.Level_2_btn})`}
      alignItems="center"
      justifyContent="space-between"
    >
      <PrimaryTextSpan fontWeight="bold" lineHeight="12px">
        {headerText}
      </PrimaryTextSpan>
      <Button leftIcon={<ClearIcon />} heightSize="small" onClick={onClose} />
    </FlexContainer>
    {children}
  </HeaderSettingsWrapper>
);

type FieldSettingsAreaProps = Omit<HeaderSettingsAreaLayoutProps, 'headerText'>;

export const FieldSettingsArea: FC<FieldSettingsAreaProps> = ({ children, ...headerProps }) => {
  return (
    <FieldSettingsAreaLayout right={settingsLayoutWidth}>
      <HeaderSettingsAreaLayout width={settingsLayoutWidth} headerText="Настроить" {...headerProps}>
        {children}
      </HeaderSettingsAreaLayout>
    </FieldSettingsAreaLayout>
  );
};
